module.exports = __webpack_public_path__ + "static/media/tag.238de233.svg";